var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gmap-input"},[_c('gmap-autocomplete',{staticClass:"gmap-input__autocomp",attrs:{"placeholder":' ',"value":_vm.value.address || ''},on:{"place_changed":_vm.locationChanged}}),_c('label',{staticClass:"gmap-input__placeholder"},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }